/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";

import "./collection-name.m.css";
import Arrow from "../../atoms/other-icons/Arrow";

const CollectionName = ({ collection, isSeeMore, hasDarkBg }) => {
  const { name, slug } = collection;
  const customSeeMore = get(collection, ["associated-metadata", "see more"], "");
  return (
    <div className="collection-name" styleName="wrapper">
      <h1>{collection.metadata?.["display-name"] || name}</h1>
      {isSeeMore ? (
        <Link href={customSeeMore || slug} styleName="seemore-link" className="headline-link">
          <div styleName="seemore">
            <span styleName={`more ${hasDarkBg ? "white-text" : ""}`}>See More </span>
            <span styleName="right-arrow">
              <Arrow color={hasDarkBg ? "white" : "black"} height="18px" width="18px" />
            </span>
          </div>
        </Link>
      ) : null}
    </div>
  );
};

CollectionName.defaultProps = {
  isSeeMore: true
};

export default CollectionName;
